"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KeyEmployeePageFour;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _utils = require("../../middleware/utils");
var _KeyEmployeeWizardCalc = require("./KeyEmployeeWizardCalc.config");
var _KeyEmployeeRefineModal = _interopRequireDefault(require("./KeyEmployeeRefineModal"));
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function KeyEmployeePageFour(_ref) {
  var {
    snapshot,
    refinementHandleClose,
    showRefinement,
    disclosureHandleClose,
    showDisclosure
  } = _ref;
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      employees,
      aveGrossProfitPrior3YearsAmount,
      shortTermAssetsEstimates,
      industrySector
    },
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_KeyEmployeeWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  var disclosureArray = ['This interactive calculator is made available to you as a self-help tool for your independent use and is not intended to provide financial advice. We cannot and do not guarantee its applicability or accuracy in regard to your individual circumstances. Examples are for illustrative purposes. We encourage you to seek personalized advice from a qualified financial professional regarding all personal finance issues. MassMutual will assume no liability for the use of or reliance on this calculator.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var collaspeEmployeeInfo = [];
  employees.forEach((employee, index) => {
    var contentArray = [{
      label: 'Years needed to Fully Replace Employee',
      value: employee.replaceEmployeeYears + ' Years',
      id: "employee".concat(index + 1, "yearsToReplace")
    }, {
      label: 'Potential Profit Loss due to Loss of Employee',
      value: calculateProfitAttributableToEmployee(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, _KeyEmployeeWizardCalc.industryMap, industrySector, _KeyEmployeeWizardCalc.industrySectorROAPercent, employee),
      id: "employee".concat(index + 1, "potentialLoss")
    }];
    var label = "Estimated value of key employee: <strong>".concat(employee.employeeId, "</strong>");
    var total = calculateEstimatedKeyEmployeeValue(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, _KeyEmployeeWizardCalc.industryMap, industrySector, _KeyEmployeeWizardCalc.industrySectorROAPercent, employee);
    var id = "employee".concat(index + 1, "estimatedValue");
    var currentEmployee = /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
      contentArray: contentArray,
      label: label,
      total: total,
      id: id
    });
    collaspeEmployeeInfo.push(currentEmployee);
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "If the loss of one or more of your key employees would take a significant bite out of your profits, it's worth thinking about taking steps to protect your bottom line."), /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  }), /*#__PURE__*/_react.default.createElement("h4", null, "Total Attributable Profits"), /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, calculateTotalAttributableProfits(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, _KeyEmployeeWizardCalc.industryMap, industrySector, _KeyEmployeeWizardCalc.industrySectorROAPercent)), collaspeEmployeeInfo, /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeRefineModal.default, {
    show: showRefinement,
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  })));
}
function calculateProfitAttributableToEmployee(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, industryMap, industrySector, industrySectorROAPercent, employee) {
  return (0, _utils.numberToCurrencyString)(((0, _utils.parseCurrencyString)(null, aveGrossProfitPrior3YearsAmount) - (0, _utils.parseCurrencyString)(null, shortTermAssetsEstimates) * industrySectorROAPercent[industryMap[industrySector]]) * parseFloat(employee.annualProfitAttributable / 100) * employee.replaceEmployeeYears);
}
function calculateEstimatedKeyEmployeeValue(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, industryMap, industrySector, industrySectorROAPercent, employee) {
  return (0, _utils.numberToCurrencyString)(((0, _utils.parseCurrencyString)(null, aveGrossProfitPrior3YearsAmount) - (0, _utils.parseCurrencyString)(null, shortTermAssetsEstimates) * industrySectorROAPercent[industryMap[industrySector]]) * parseFloat(employee.annualProfitAttributable / 100));
}
function calculateTotalAttributableProfits(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, industryMap, industrySector, industrySectorROAPercent) {
  return (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, aveGrossProfitPrior3YearsAmount) - (0, _utils.parseCurrencyString)(null, shortTermAssetsEstimates) * industrySectorROAPercent[industryMap[industrySector]]);
}